import ProductCarousel from "../Components/ProductCarousel.vue"
import ProductCard from "../Components/ProductCard.vue"
import ShopSidebar from "../Components/ShopSidebar.vue"
import ProductFilterPill from "../Components/ProductFilterPill.vue"
import ResultsCounter from '../Components/ResultsCounter.vue'
import Pagination from '../Components/Pagination.vue'

import Vue from "vue/dist/vue.common";
import Vuex, {
  mapActions,
  mapGetters
} from "vuex";
import {
  Mutations
} from "./mutations";
import {
  Actions
} from "./actions";
import {
  Getters
} from "./getters";

const bodyClassList = document.body.classList
if (bodyClassList.contains('woocommerce-shop') || bodyClassList.contains('tax-product_cat')) {

  Vue.use(Vuex);

  let filters = []
  if (TG.vue.filters) {
    filters = typeof TG.vue.filters == 'object' ? Object.values(TG.vue.filters) : TG.vue.filters
  }

  let state = {
    categories: TG.vue.categories,
    products: [],
    filters,
    lang: TG.vue.lang != null ? TG.vue.lang : 'en',
    attributes: TG.vue.attributes != null ? TG.vue.attributes : [],
    sampleOptions: TG.vue.sample_options != null ? TG.vue.sample_options : [],
    searchUpdateNeeded: false
  }

  const updateProducts = store => {
    store.subscribe((mutation, state) => {
      if (["ADD_FILTER", 'REMOVE_FILTER', 'CLEAR_FILTERS'].includes(mutation.type)) {
        store.dispatch('filterProducts')
      }

      if (['UPDATE_PRODUCTS', 'SET_PRODUCTS', 'CLEAR_PRODUCTS'].includes(mutation.type)) {
        Vue.set(state, 'isUpdatingProducts', false)
      }
    })
  }


  const store = new Vuex.Store({
    state,
    getters: Getters,
    mutations: Mutations,
    actions: Actions,
    plugins: [updateProducts]
  });

  new Vue({
    data() {
      return {
        timeInterval: null
      }
    },
    el: '#main',
    store,
    components: {
      'product-card': ProductCard,
      'results-counter': ResultsCounter,
      'pagination': Pagination,
      'shop-sidebar': ShopSidebar,
      'product-carousel': ProductCarousel,
      'product-filter-pill': ProductFilterPill
    },
    methods: {
      ...mapActions([
        'clearFilters',
        'updateCategories',
        'loadAttributes',
        'loadAttributeTerms',
        'filterProducts'
      ])
    },
    computed: {
      ...mapGetters({
        lang: 'getLang',
        products: 'getProducts',
        getFilters: 'getFilters',
        elements: 'getElements',
        categories: 'categories',
        isUpdatingProducts: 'isUpdatingProducts',
        attributes: 'attributes',
        hasActiveFilters: 'hasActiveFilters'
      }),
      hasProducts() {
        return this.products.length > 0
      }
    },
    beforeMount() {
      if (!this.hasProducts) {
        this.filterProducts()
      }
      if (this.categories.length <= 0) {
        this.updateCategories()
      }
      if (this.attributes.length <= 0) {
        this.loadAttributes()
      } else {
        this.attributes.forEach(attribute => {
          this.loadAttributeTerms(attribute.id)
        })
      }
    }
  }).$mount()

}